<template>
  <div class="purchaseManage">
    <div class="list">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh" style="min-height:100%">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="getList"
          :offset="10"
        >
          <div
            class="list-item"
            v-for="(item,index) in list"
            :key="index"
            @click="toPurchaseDetail(item.id)"
          >
            <div class="list-content">
              <div>
                <div class="header_name">
                  <span>货&emsp;&emsp;主：</span>
                  <span class="van-ellipsis">{{item.supplier_name}}</span>

                  <div class="item_type item_type_zy" v-if="item.type == 1">自营</div>
                  <div class="item_type item_type_dm" v-else>代卖</div>
                </div>
                <div>批次号：{{item.batch_no}}</div>
                <div class="van-ellipsis">货品：{{item.goods}}</div>
                <div>进货量：{{ item.batch_weight_kg*1}}公斤</div>
                <div>货款：{{item.batch_amount|numToFixed(2)}}元</div>
                <div>总附加费：{{item.surcharge_amount|numToFixed(2)}}元</div>
                <div>总成本：{{item.goods_surcharge_amount_total|numToFixed(2)}}元</div>
              </div>
            </div>
            <div class="list-date">
              <span>进货时间：</span>
              <span>{{item.created_at|toTime}}</span>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <div class="bottom" @click="$router.push('/manage/stock/addStock')">进货</div>
  </div>
</template>

<script>
import { purchase_list } from "@/api/work/manage/purchase.js";
import { timestampToTime } from "@/utils/timestamp";
export default {
  name: "purchaseManage",
  filters: {
    numToFixed(num, val = 2) {
      return (num * 1).toFixed(val);
    },
    toTime(t) {
      return timestampToTime(t);
    }
  },
  data() {
    return {
      list: [],
      loading: true,
      finished: true,
      refreshing: false, //刷新
      listQuery: {
        page: 1,
        pageSize: 15
      }
    };
  },
  created() {
    this.getList();
    this.$navigation.on("back", (to, from) => {
      if (from.route.name == "manage_stock_addStock") {
        var listQuery = {
          page: 1,
          pageSize: this.finished?this.list.length+1:this.list.length
        };
        purchase_list(listQuery).then(res => {
          if (res.code == 200) {
            let arr = res.data.list.map(ele => {
              

              if (!ele.goods || ele.goods.length == 0) {
                ele.goods = [{ name: "暂无" }];
              }
              ele.goods = ele.goods
                .map(el => {
                  return (el = el.name);
                })
                .join("，");
              return ele;
            });

            this.list = arr;
            if (
              this.list.length == res.data.totalCount ||
              res.data.list.length == 0
            ) {
              this.finished = true;
            } else {
              this.finished = false;
              this.loading = false;
              this.listQuery.pageSize = "15";
            }
            this.refreshing = false;
          }
        });
      }
    });
  },
  mounted() {},
  methods: {
    // 获取列表
    getList() {
      purchase_list(this.listQuery).then(res => {
        if (res.code == 200) {
          if (this.listQuery.page == 1) this.list = [];
          let arr = res.data.list.map(ele => {
           

            if (!ele.goods || ele.goods.length == 0) {
              ele.goods = [{ name: "暂无" }];
            }
            ele.goods = ele.goods
              .map(el => {
                return (el = el.name);
              })
              .join("，");
            return ele;
          });
          this.list = this.list.concat(arr);
          if (
            this.list.length == res.data.totalCount ||
            res.data.list.length == 0
          ) {
            this.finished = true;
          } else {
            this.finished = false;
            this.loading = false;
            this.listQuery.page++;
          }
          this.refreshing = false;
        }
      });
    },
    // 下拉刷新
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      this.refreshing = true;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.listQuery.page = 1;
      this.getList();
    },
    toPurchaseDetail(id) {
      this.$router.push({
        path: "/manage/purchase/purchaseDetail",
        query: {
          id
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.purchaseManage {
  position: relative;
  padding-bottom: 1rem;
  .flex {
    display: flex;
    align-items: center;
  }
  .list-content {
    & > div {
      & > div {
        width: 80%;
        span {
          white-space: nowrap;
        }
      }
    }
  }
  .header_name {
    display: flex;
    align-items: center;
    span:nth-child(2) {
      flex-shrink: 1;
    }
  }
  .item_type {
    font-size: 0.24rem;
    text-align: center;
    line-height: 0.32rem;
    white-space: nowrap;
    margin-left: 0.3rem;
    display: block;

    text-align: center;
    border-radius: 0.06rem;
    padding: 0.05rem 0.1rem;
  }
  .item_type_zy {
    background: rgba(28, 192, 233, 0.3);
    color: #268ea7;
  }
  .item_type_dm {
    background: rgba(233, 153, 28, 0.3);
    color: #c6601c;
  }
  .list-item {
    border-radius: 0.16rem;
    width: 6.5rem;
    margin: 0.2rem auto 0;
    background-color: #fff;
    padding: 0.2rem;
    position: relative;
    font-size: 0.32rem;
    color: #333333;
    line-height: 0.51rem;
  }
  .list-date {
    font-size: 0.28rem;
    padding-top: 0.1rem;
    color: rgb(153, 153, 153);
    border-top: 1px solid rgb(245, 245, 245);
  }

  .bottom {
    background-color: #31b158;
    color: #fff;
    font-size: 0.36rem;
    line-height: 1rem;
    text-align: center;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
  }
}
</style>